// extracted by mini-css-extract-plugin
var _1 = "ChapterPathStaircase__img--hKE7w ChapterPathStyles__antiSeams--XNFsH ChapterPathStyles__antiLag--A6PV1";
var _2 = "ChapterPathStaircase__main--wvhkL";
var _3 = "ChapterPathStaircase__mainButton--G5KzN ChapterPathStaircase__main--wvhkL";
export { _1 as "img", _2 as "main", _3 as "mainButton" }
